export default function(state=[], action) {

    switch(action.type) {
        case "OPTIONS":
            return action.payload;

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerFormOptions.js